import { CompleteArrow } from "src/assets";
import { lowerLanguage } from "src/i18n";
import { Document } from "src/types";
import { Button } from "src/ui/widgets";

import { useDocuments } from "./documents.hook";

export const Documents = ({ isLandingPage }: { isLandingPage?: boolean }) => {
  const { t, documents, openDocument } = useDocuments();

  const Title = (
    <h3
      className={`mb-4 d-flex align-item-center text-uppercase documents-dynamic-size-title${
        isLandingPage ? "-landingPage" : ""
      }`}
    >
      {t("landing.section_6_title")}
    </h3>
  );

  const Subtitle = (
    <div className="mb-4 documents-dynamic-size-subtitle d-flex align-items-center white-space-pre-subtitle">
      {t("landing.section_6_subtitle")}
    </div>
  );

  const Document = ({ docCode, fileName, filePath }: Document) => (
    <div key={docCode}>
      {docCode && (
        <div>
          <div className="pe-md-3 d-flex align-items-center justify-content-between">
            <div className="documents-dynamic-size-document-title">
              {fileName?.[lowerLanguage]}
            </div>

            <Button
              text={t("commons.download")}
              iconRight={CompleteArrow}
              iconSize={18}
              flavor="transparentAccent"
              classes="p-2 pb-0 ps-3 pe-3 pe-md-0 d-flex align-items-center c-2727ab"
              classesText="documents-dynamic-size-document-title"
              classesIconRight="filter-00686F ms-2"
              onPress={() => openDocument(filePath[lowerLanguage])}
            />
          </div>
          <div className="documents-separator" />
        </div>
      )}
    </div>
  );

  const Documents = (
    <div className="pt-4 pt-md-0">
      <div>{documents?.map(Document)}</div>
    </div>
  );

  return (
    <div className={"col-xl-12 d-xl-flex justify-content-center bg-white"}>
      <div className="col-xl-6 mb-5">
        {Title}
        {Subtitle}
      </div>
      <div className="col-xl-6">{Documents}</div>
    </div>
  );
};
